import { useCallback, useRef, useEffect } from 'react';

export default function useNotificationSound() {
  const originalTitle = useRef(document.title);
  const flashInterval = useRef(null);
  const isFlashing = useRef(false);

  // Limpar flash ao desmontar
  useEffect(() => {
    const title = originalTitle.current;
    return () => {
      if (flashInterval.current) {
        clearInterval(flashInterval.current);
      }
      document.title = title;
    };
  }, []);

  // Parar flash quando a aba ganha foco
  useEffect(() => {
    const handleFocus = () => {
      if (flashInterval.current) {
        clearInterval(flashInterval.current);
        flashInterval.current = null;
      }
      isFlashing.current = false;
      document.title = originalTitle.current;
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, []);

  const playSound = useCallback(type => {
    try {
      const file =
        type === 'queue' ? '/sounds/notification.mp3' : '/sounds/message.mp3';
      const volume = type === 'queue' ? 0.5 : 0.3;
      const audio = new Audio(file);
      audio.volume = volume;
      audio.play().catch(() => {});
    } catch (e) {
      // silent — navegador pode bloquear autoplay
    }
  }, []);

  const flashTitle = useCallback(text => {
    if (isFlashing.current) return;
    if (document.hasFocus()) return;

    isFlashing.current = true;
    let show = true;

    flashInterval.current = setInterval(() => {
      document.title = show ? text : originalTitle.current;
      show = !show;
    }, 1500);
  }, []);

  const notifyNewQueueItem = useCallback(
    customerName => {
      playSound('queue');
      flashTitle(`${customerName || 'Cliente'} aguardando`);
    },
    [playSound, flashTitle]
  );

  const notifyNewMessage = useCallback(
    customerName => {
      playSound('message');
      flashTitle(`Nova mensagem de ${customerName || 'Cliente'}`);
    },
    [playSound, flashTitle]
  );

  return {
    notifyNewQueueItem,
    notifyNewMessage,
  };
}
